import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, setSessionToken } from "@/lib/api";
import { FormDialog } from "@/components/common";

const fields = [
  { name: "current_password", label: "Current password", type: "password", required: true },
  { name: "new_password", label: "New password (8+ characters, with a number or symbol)", type: "password", required: true },
  { name: "confirm", label: "Confirm new password", type: "password", required: true },
];

export function ChangePassword() {
  const [open, setOpen] = useState(false);
  const submit = async (v) => {
    if (v.new_password !== v.confirm) throw new Error("New passwords don't match");
    const { data } = await api.post("/auth/change-password", { current_password: v.current_password, new_password: v.new_password });
    setSessionToken(data.token);
    toast.success("Password changed. Other sessions have been signed out.");
  };
  return (
    <>
      <button data-testid="change-password-btn" onClick={() => setOpen(true)} className="rounded-lg p-2 text-slate-500 transition-colors hover:bg-slate-100" title="Change password"><KeyRound className="h-4 w-4" /></button>
      <FormDialog open={open} onOpenChange={setOpen} title="Change password" testid="change-password-form" fields={fields} onSubmit={submit} submitLabel="Change password" />
    </>
  );
}
